const TicketCheapType = {
  ADD: 'cheap/Add',
};

export default TicketCheapType;
